import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { ThemeProvider, B2BTheme } from "@cin7/ui";
//Layout
import Layout from "./Pages/Layout";
import RestrictedPage from "./Pages/Login/RestrictedPage";

//Page Views
import { Index } from "./Pages/Landing/Index";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Login/Register";
import PageNotFound from "./Pages/Notifications/Errors/PageNotFound";
import Products from "./Pages/Products/Products";
import SellerContent from "./Pages/SellerContent/SellerContent";
import Account from "./Pages/Account/Account";
import { CustomHomepage } from "./Pages/Landing/CustomHomepage";

//Notification Views
import FailedView from "./Pages/Notifications/Errors/FailedView";
import Orders from "./Pages/Orders/Orders";
import { ProductDetailsModal } from "./Components/Global/ProductDetailsModal";
import { ContactUs } from "./Pages/Login/ContactUs";
import { ContactUsConfirmation } from "./Pages/Login/ContactUsConfirmation";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import APIHost from "./APIHost";

class App extends Component<{}, {}> {

    componentDidMount() {
        const environment = APIHost.GetEnvironment() ?? undefined;
        if (environment && environment !== "development") {
            const host = new APIHost();
            const connectionString: string = host.appSettings.AppInsightsConnectionString;
            if (connectionString) {
                const appInsights = new ApplicationInsights({
                    config: {
                        connectionString,
                        enableAutoRouteTracking: true,
                        enableAjaxErrorStatusText: true,
                        enableCorsCorrelation: true,
                        correlationHeaderExcludedDomains: ["*.in.applicationinsights.azure.com"],
                        samplingPercentage: 30,
                    },
                });
                appInsights.loadAppInsights();
                appInsights.addTelemetryInitializer((envelope) => {
                    envelope.tags = envelope.tags || [];
                    envelope.tags["ai.cloud.role"] = "B2B-UI";
                    envelope.tags["ai.application.ver"] = process.env.REACT_APP_RELEASE_VERSION ?? "";
                    envelope.data = envelope.data || {};
                    envelope.data["Environment"] = environment;
                });
                appInsights.trackPageView();
                // Session replay was not migrated — Datadog had startSessionReplayRecording().
                // App Insights has no native equivalent; add Microsoft Clarity if replay is needed.
                // Decided to add this later, which should be easy enough following : https://www.npmjs.com/package/@microsoft/clarity
            }
        }
    }

    render() {
        return (
            <ThemeProvider theme={B2BTheme as any}>
                <Layout>
                    <Switch>
                        <Route exact path="/" component={Index} />
                        <Route path="/login" component={Login} />
                        <Route path="/contact-us" component={ContactUs} />
                        <Route path="/contact-us-confirmation" component={ContactUsConfirmation} />
                        <Route path="/registration" component={Register} />
                        <RestrictedPage path="/home" component={CustomHomepage} />
                        <RestrictedPage path="/products" component={Products} />
                        <RestrictedPage path="/orders" component={Orders} />
                        <RestrictedPage path="/cart" component={Orders} />
                        <RestrictedPage path="/checkout" component={Orders} />
                        <RestrictedPage path="/seller" component={SellerContent} />
                        <RestrictedPage path="/account" component={Account} />
                        <Route exact path="/something-went-wrong" component={FailedView} />
                        <Route path="/*" component={PageNotFound} />
                    </Switch>

                    <ProductDetailsModal />
                    <div className="clear-space"></div>
                </Layout>
            </ThemeProvider>
        );
    }
}

export default App;
